module.exports = __webpack_public_path__ + "img/b2.3e12fe6c.jpg";